import { IRestClientRequestQueryParams } from '../RestClientRequestController/RestClientRequestController.types';

export function uriQueryParamsToString(
  queryParams: IRestClientRequestQueryParams | undefined
): string {
  return queryParams
    ? '?' +
        Object.entries(queryParams)
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
          .join('&')
    : '';
}

export function isJSONResponse(response: Response): boolean {
  return !!response.headers
    .get('Content-Type')
    ?.split(';')
    .map((part) => part.trim())
    .includes('application/json');
}
